export function error(isError, component, message) {
  if (!!isError && console !== undefined) {
    console.error("[Error][zen-design ".concat(component, "]: ").concat(message));
  }
}